import React from "react";
import ReactDOM from "react-dom";
import App from "./AppPage";
import * as serviceWorker from "./serviceWorker";
import "./assets/css/style.min.css";
import rtl from "jss-rtl";
import { Provider } from "react-redux";
import store from "./store";
import "./assets/css/all.css";
import "./assets/css/fontawesome.min.css";
import {
  MuiThemeProvider,
  createMuiTheme,
  jssPreset
} from "@material-ui/core/styles";
import { create } from "jss";
import JssProvider from "react-jss/lib/JssProvider";

const theme = createMuiTheme({
  direction: "rtl"
});
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
if ('serviceWorker' in navigator) {

  // navigator
  //   .serviceWorker
  //   .register('./sw.js').then(registration => {
  //     console.log("registered complete");
  //   }).catch(err => {
  //     console.log("registered error");
  //   })

    navigator
    .serviceWorker
    .register("./firebase-messaging-sw.js").then(registration => {
      console.log("registered firebase-messaging-sw complete");
    }).catch(err => {
      console.log("registered firebase-messaging-sw error");
    })

    
} else {
}


ReactDOM.render(
  <JssProvider jss={jss}>
    <MuiThemeProvider theme={theme}>
      <Provider store={store}>
        <App />
      </Provider>
    </MuiThemeProvider>
  </JssProvider>,

  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
